export default [
    {
        path: '/admin/users',
        name: 'adminUsers',
        component: () => import('@/views/users/UsersAdminView.vue')
    }
]
